import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { summaryExeDateUpd, summaryExeDateAdd } from "@/api/updateConfiguration/updateConfiguration";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      form: {
        id: "",
        start_date: "",
        end_date: ""
      },
      rules: {
        start_date: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        end_date: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    // 打开修改新增
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (row) {
                  _this.form = _objectSpread({}, row);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭弹窗或取消修改新增
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.form = {
        id: "",
        start_date: "",
        end_date: ""
      };
      this.$refs.ruleForm.clearValidate();
    },
    // 确定添加修改
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          var reqFn = _this2.form.id ? summaryExeDateUpd : summaryExeDateAdd;
          reqFn(_this2.form).then(function (res) {
            if (res.status == 200) {
              _this2.$message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    }
  }
};